import { SystemPageKey } from '@internal/page/SystemPageKey';
import { useMachineTypeName } from '@internal/utils/machine/useMachineTypeName';
import { TButtonData } from '@renderer-ui-library/molecules';
import { useCallback } from 'react';
import { urlFor } from './urlFor';
import { urlForSystemPageWithoutParams } from './urlForSystemPageWithoutParams';

export const usePrioritizedUrl = () => {
    const { getMachineTypeName } = useMachineTypeName();

    const getPrioritizedUrl = useCallback(
        ({
            url,
            systemPage,
            machineCategoryPage,
            page,
        }: Pick<
            TButtonData,
            'url' | 'systemPage' | 'machineCategoryPage' | 'page'
        >) => {
            if (machineCategoryPage?.data) {
                return urlFor(machineCategoryPage.data.attributes.locale, {
                    key: SystemPageKey.SearchResults,
                    machineTypeName: getMachineTypeName(
                        machineCategoryPage.data.attributes.machineType,
                        'plural',
                    ),
                    brandSlug: machineCategoryPage.data.attributes.brandSlug,
                    modelSlug: machineCategoryPage.data.attributes.modelSlug,
                });
            }

            if (systemPage?.data) {
                return urlForSystemPageWithoutParams(
                    systemPage.data.attributes.locale,
                    systemPage.data.attributes.key,
                );
            }

            if (page?.data) {
                return urlFor(
                    page.data.attributes.locale,
                    page.data.attributes.slug,
                );
            }

            return url ? url : undefined;
        },
        [getMachineTypeName],
    );

    return { getPrioritizedUrl };
};
